<p-panel>
  <ng-container *ngIf="isReactiveFormReady; else reactiveFormLoadingState">
    <app-reactive-form-builder
      [form]="formFields"
      [id]="reactiveFormRecordId"
      [request]="request"
      [getRequest]="getRequest"
      [previousData]="initialPreviousData"
      [undoEnabled]="undoEnabled"
      (stableValueChanges)="stableValueChanges($event)"
      (internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
      (goBack)="goBack()">
    </app-reactive-form-builder>
  </ng-container>
</p-panel>

<ng-template #reactiveFormLoadingState>
  <div class="p-3 text-center" role="status" aria-live="polite">
    <div *ngIf="!reactiveFormLoadingError" class="text-muted">
      {{ reactiveFormLoadingLabel }}
    </div>
    <div *ngIf="reactiveFormLoadingError" class="alert alert-danger mb-0" role="alert">
      {{ reactiveFormLoadingError }}
    </div>
  </div>
</ng-template>
